import { call, put, takeLatest } from 'redux-saga/effects';
import alertConfigurationService from '../../../services/alertConfigurationService';
import {
  fetchInit,
  fetchInitSuccess,
  fetchInitFailure,
  fetchAlertConfigurations,
  fetchAlertConfigurationsSuccess,
  fetchAlertConfigurationsFailure,
  fetchAlertConfigurationById,
  fetchAlertConfigurationByIdSuccess,
  fetchAlertConfigurationByIdFailure,
  createAlertConfiguration,
  createAlertConfigurationSuccess,
  createAlertConfigurationFailure,
  updateAlertConfiguration,
  updateAlertConfigurationSuccess,
  updateAlertConfigurationFailure,
  deleteAlertConfiguration,
  deleteAlertConfigurationSuccess,
  deleteAlertConfigurationFailure,
  toggleActive,
  toggleActiveSuccess,
  toggleActiveFailure,
} from './slice';

function* handleFetchInit() {
  try {
    // Fetch init data from API endpoint
    const initResponse = yield call(alertConfigurationService.getInit);
    
    // Extract data from response - API returns data directly or wrapped in data property
    const responseData = initResponse?.data || initResponse;
    const units = responseData?.units || [];
    const alertTypes = responseData?.alertTypes || [];
    const notificationMethods = responseData?.notificationMethods || [];
    
    console.log('[AlertConfigurations Saga] Fetched init data:', {
      units: units.length,
      alertTypes: alertTypes.length,
      notificationMethods: notificationMethods.length,
      responseData,
    });
    
    yield put(fetchInitSuccess({
      units,
      alertTypes,
      notificationMethods,
    }));
  } catch (error) {
    console.error('[AlertConfigurations Saga] Error fetching init data:', error);
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch initial data';
    yield put(fetchInitFailure(errorMessage));
  }
}

function* handleFetchAlertConfigurations(action) {
  try {
    const params = action.payload || {};
    const response = yield call(alertConfigurationService.getAlertConfigurations, params);
    yield put(fetchAlertConfigurationsSuccess(response));
  } catch (error) {
    yield put(fetchAlertConfigurationsFailure(error.message));
  }
}

function* handleFetchAlertConfigurationById(action) {
  try {
    const response = yield call(alertConfigurationService.getAlertConfigurationById, action.payload);
    yield put(fetchAlertConfigurationByIdSuccess(response));
  } catch (error) {
    yield put(fetchAlertConfigurationByIdFailure(error.message));
  }
}

function* handleCreateAlertConfiguration(action) {
  try {
    yield call(alertConfigurationService.createAlertConfiguration, action.payload);
    yield put(createAlertConfigurationSuccess());
    // Refresh list
    yield put(fetchAlertConfigurations());
  } catch (error) {
    yield put(createAlertConfigurationFailure(error.message));
  }
}

function* handleUpdateAlertConfiguration(action) {
  try {
    const { id, alert } = action.payload;
    yield call(alertConfigurationService.updateAlertConfiguration, id, alert);
    yield put(updateAlertConfigurationSuccess());
    // Refresh list
    yield put(fetchAlertConfigurations());
  } catch (error) {
    yield put(updateAlertConfigurationFailure(error.message));
  }
}

function* handleDeleteAlertConfiguration(action) {
  try {
    yield call(alertConfigurationService.deleteAlertConfiguration, action.payload);
    yield put(deleteAlertConfigurationSuccess());
    // Refresh list
    yield put(fetchAlertConfigurations());
  } catch (error) {
    yield put(deleteAlertConfigurationFailure(error.message));
  }
}

function* handleToggleActive(action) {
  try {
    yield call(alertConfigurationService.toggleActive, action.payload);
    yield put(toggleActiveSuccess());
    // Refresh list
    yield put(fetchAlertConfigurations());
  } catch (error) {
    yield put(toggleActiveFailure(error.message));
  }
}

export function* watchAlertConfigurationsActions() {
  yield takeLatest(fetchInit.type, handleFetchInit);
  yield takeLatest(fetchAlertConfigurations.type, handleFetchAlertConfigurations);
  yield takeLatest(fetchAlertConfigurationById.type, handleFetchAlertConfigurationById);
  yield takeLatest(createAlertConfiguration.type, handleCreateAlertConfiguration);
  yield takeLatest(updateAlertConfiguration.type, handleUpdateAlertConfiguration);
  yield takeLatest(deleteAlertConfiguration.type, handleDeleteAlertConfiguration);
  yield takeLatest(toggleActive.type, handleToggleActive);
}

